import { getApiWrapper, postApiWrapper } from "./wrapper";
export const getTLFeed = async () => {
    const url = `https://demomeghwal.merasamaj.app/api/social_events`;
    const result = await getApiWrapper(url);
    return result.result.events;
  }
